export var attachmentsUrl = '/candidate/profile/editor/api/v1/attachments';
export var gcsConfigUrl = '/candidate/profile/editor/api/v1/config';
export var MODAL_DATA_AT = 'registration-success-modal';
export var REDIRECT_TO_PROFILE_URL = '/profile';
//# sourceMappingURL=consts.js.map